import { useState } from 'react'

function FAQItem({ q, a, open, onToggle }) {
  return (
    <div className="border-b border-slate-200 last:border-0">
      <button
        onClick={onToggle}
        className="w-full flex items-start justify-between gap-4 py-5 text-left group"
        aria-expanded={open}
      >
        <span className="font-display font-medium text-kart-night text-base leading-snug group-hover:text-kart-blue transition-colors">
          {q}
        </span>
        <span
          className={`shrink-0 mt-0.5 w-6 h-6 rounded-full flex items-center justify-center border-2 transition-all duration-200 ${
            open
              ? 'border-kart-blue bg-kart-blue text-white rotate-45'
              : 'border-slate-300 text-slate-400'
          }`}
          aria-hidden="true"
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 5v14M5 12h14" />
          </svg>
        </span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${open ? 'max-h-96 pb-5' : 'max-h-0'}`}
        aria-hidden={!open}
      >
        <p className="text-slate-600 leading-relaxed">{a}</p>
      </div>
    </div>
  )
}

export default function FAQAccordion({ items, allowMultiple = false }) {
  const [openIndexes, setOpenIndexes] = useState([])

  function toggle(i) {
    if (allowMultiple) {
      setOpenIndexes(prev =>
        prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]
      )
    } else {
      setOpenIndexes(prev => (prev[0] === i ? [] : [i]))
    }
  }

  return (
    <div className="divide-y-0">
      {items.map((item, i) => (
        <FAQItem
          key={i}
          q={item.q}
          a={item.a}
          open={openIndexes.includes(i)}
          onToggle={() => toggle(i)}
        />
      ))}
    </div>
  )
}
